import * as React from "react";
import {Option} from "ts-option";
import DataGrid from "../../../../../hiberUiKit/src/organisms/DataGrid/DataGrid";
import AssetMaterialsBreakdown from "../../../../../model/asset/AssetMaterialsBreakdown";
import SectionView from "../../../../layout/section/SectionView";

interface ComponentProps {
	/**
	 * List of asset materials for each merchant
	 */
	materialsBreakdown: Option<AssetMaterialsBreakdown[]>;
}

interface State {
	/**
	 * Indicates for each merchant if its materials list is visible
	 */
	merchantsDisplay: Array<boolean>;
}

export default class AssetMaterialsBreakdownTable extends React.Component<ComponentProps, State> {

	constructor(props: ComponentProps) {
		super(props);
		this.state = {
			merchantsDisplay: props.materialsBreakdown.getOrElse([]).map(() => true)
		};
		this.toggleMerchantDisplay = this.toggleMerchantDisplay.bind(this);
	}

	render() {
		return (
			<SectionView>
				<DataGrid>
					<thead>
					<tr>
						<th>Description</th>
						<th>Merch.#</th>
						<th>Quantity</th>
						<th className={"t-right"}>Buy price</th>
					</tr>
					</thead>
					<tbody>
					{this.props.materialsBreakdown.getOrElse([]).map((item, index) => {
						return (
							<React.Fragment key={index}>
								<tr>
									<td>
										<a className={"t-burgundy-color a-pointer"}
										   onClick={() => this.toggleMerchantDisplay(index)}>
											<span
												className={`${this.state.merchantsDisplay[index] ? "d-inline-block" : "d-none"}`}>
												<i className={"fa fa-fw fa-caret-down"}/>
											</span>
											<span
												className={`${this.state.merchantsDisplay[index] ? "d-none" : "d-inline-block"}`}>
												<i className={"fa fa-fw fa-caret-up"}/>
											</span>
											<b className={"t-uppercase"}>{item.merchantName}</b>
										</a>
									</td>
									<td></td>
									<td></td>
									<td className={"t-right"}>
										<b>{item.calculateTotalBuyPricePerMerchant().format()}</b>
									</td>
								</tr>
								{this.state.merchantsDisplay[index] && item.materials.map((material, mIndex) => {
									return (
										<tr className={"is-details-row"} key={mIndex}>
											<td className={"t-uppercase"}>{material.description}</td>
											<td>{material.merchantCode}</td>
											<td>{material.quantity}</td>
											<td className={"t-right"}>
												{material.price.map(price => price.format()).getOrElse('-')}
											</td>
										</tr>
									)
								})}
							</React.Fragment>
						)
					})}
					</tbody>
				</DataGrid>
			</SectionView>
		)
	}

	toggleMerchantDisplay(merchantIndex: number) {
		const display = this.state.merchantsDisplay.map((disp, index) => index === merchantIndex ? !disp : disp);
		this.setState({merchantsDisplay: display});
	}

}
